var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 23 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-62,-3308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medaille"
  }, /*#__PURE__*/React.createElement("path", {
    id: "award",
    d: "M73.5,3330.5C67.149,3330.5 62,3325.46 62,3319.25C62,3313.04 67.149,3308 73.5,3308C79.851,3308 85,3313.04 85,3319.25C85,3325.46 79.851,3330.5 73.5,3330.5ZM81.166,3330.01L81.166,3336.12C81.166,3337.16 80.308,3338 79.25,3338C78.721,3338 78.241,3337.79 77.894,3337.45L73.5,3333.15L69.105,3337.45C68.932,3337.62 68.725,3337.76 68.496,3337.85C68.266,3337.95 68.014,3338 67.75,3338C67.22,3338 66.741,3337.79 66.394,3337.45C66.221,3337.28 66.081,3337.08 65.984,3336.85C65.887,3336.63 65.833,3336.38 65.833,3336.12L65.833,3330.01C68.007,3331.5 70.647,3332.37 73.5,3332.37C76.352,3332.37 78.992,3331.5 81.166,3330.01Z",
    style: {
      fill: "rgb(209,49,53)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "assets/media/medal.58b34271352fbdaa2c530576c11fa907.svg";
export { ForwardRef as ReactComponent };